(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminFileDisplaySettingsController', AdminFileDisplaySettingsController);

    function AdminFileDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'file_restrict',
                'file_allowed_types',
                'file_expiry_notification_time'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);

        const fileTypes = vm.settings.file_allowed_types?.value ? vm.settings.file_allowed_types.value.slice() : [];

        vm.displaySettings = fileTypeService.mergeHeifHeic(fileTypes);
    }
})();
